import styled, {css} from "styled-components";

export const WrapperPositionContextDefaultBox = styled.div<{verticalMode?: boolean}>`
    z-index: 1;
    position: relative;
    ${props => props.verticalMode ? css`
        width: 4rem;
        height: 7rem;
        margin-right: 0;
    ` : css`
        width: 11rem;
        height: 4rem;
        @media ${props => props.theme.mediaQuery.lAndBelow} {
            width: 8rem;
        }
        margin-right: 0.8rem;
    `}
    flex: 0 0 auto;
`;
